import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from '~/axios';

import { COURSE_CATEGORIES } from "~/constants/course-categories";

import moment from 'moment';
import {
    Card,
    Collapse,
    Form,
    Input,
    Button,
    Row,
    Col,
    Select,
    DatePicker,
    Radio,
    Modal,
    Spin,
    Popover,
    Icon,
} from 'antd';

const { TextArea } = Input;

import FitTestingMessage from "./FitTestingMessage";

import ScheduledSessions from './ScheduledSessions';
import UnscheduledSessions from './UnscheduledSessions';
import FormItem from '../_global/FormItem';

const defaultState = {
    loading: false,
    // default form data
    data: {
        coc: 'Bella Bella/Bella Coola',
        sector: 'Acute',
    },

    // Initial data for sessions
    initialData: {
        // List of unique dates for each scheduled day (1, 2, 3, etc)
        // We'll pull in the sessions for these scheduled days dynamically based on the selected date
        scheduledDates: null,
        // The sessions for each categorized but unscheduled session
        unscheduledSessions: null,
    },


    submitting: false,
    // 'checked' / selected sessions
    selectedSessions: {
        scheduled: {},
        unscheduled: {}
    },

    // The state of schedule session's date filter
    dateFilters: {},

    // controls whether the 'form complete' modal is shown
    showCompleteModal: false,
};

class RegistrationForm extends Component {
    constructor(params) {
        super(params);
        this.state = defaultState;
        this.handleSessionSelected = this.handleSessionSelected.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setSelectedSessions = this.setSelectedSessions.bind(this);
    }


    resetForm() {
        this.props.form.resetFields();
        // Persist initial data pulled from the API on mount but reset everything else
        const initialData = this.state.initialData;
        this.setState({ ...defaultState, initialData });
    }

    getSelectedSessions(type, key) {
        const sessionsOfType = this.state.selectedSessions[type]
        const sessionsOfKey = sessionsOfType && sessionsOfType[key] ? sessionsOfType[key] : [];
        return sessionsOfKey;
    }

    getAllSelectedSessionIDs() {
        const selectedSessions = this.state.selectedSessions;
        const allSelectedSessions = [];
        for (const [type, sessionsOfType] of Object.entries(selectedSessions)) {
            for (const [key, sessionsOfKey] of Object.entries(sessionsOfType)) {
                allSelectedSessions.push(...sessionsOfKey.map(x => x.sessionID));
            }
        }
        return allSelectedSessions;
    }

    setSelectedSessions(type, key, sessions) {
        this.setState({
            selectedSessions: {
                ...this.state.selectedSessions,
                [type]: {
                    ...this.state.selectedSessions[type],
                    [key]: sessions
                }
            }
        })
    }

    addSelectedSession(type, key, session) {
        // console.log(type, key, session)
        const currentSessions = this.getSelectedSessions(type, key);
        // If session is not already selected, add it
        if (!currentSessions.find(x => x.sessionID === session.sessionID)) {
            currentSessions.push(session)
            // console.log(currentSessions)
            this.setSelectedSessions(type, key, currentSessions)
        }

    }

    removeSelectedSession(type, key, session) {
        const currentSessions = this.getSelectedSessions(type, key);
        // If session is selected, remove it
        if (currentSessions.find(x => x.sessionID === session.sessionID)) {
            const newSessions = currentSessions.filter(x => x.sessionID !== session.sessionID)
            this.setSelectedSessions(type, key, newSessions)
        }
    }

    /**
     * @param {"scheduled"|"unscheduled"} type
     * @param {string} key
     */
    getDateFilter(type, key) {
        const dateFilter = this.state.dateFilters[type + key]
        return dateFilter;
    }

    /**
     * @param {"scheduled"|"unscheduled"} type
     * @param {string} key
     * @param newFilterState
     */
    setDateFilter(type, key, newFilterState) {

        this.setState({
            dateFilters: {
                ...this.state.dateFilters,
                [type + key]: newFilterState
            }
        })

        if (!this.state.loading) this.removeSelectedUncategorizedSessions(type, key);
    }

    removeSelectedUncategorizedSessions(type, key) {
        // Get all sessions for type and key
        const sessions = this.getSelectedSessions(type, key);
        // Filter out all uncategorized sessions
        const categorizedSessions = sessions.filter(session => session.course.course_category_id)
        // Update selected sessions
        this.setSelectedSessions(type, key, categorizedSessions);
    }

    async componentDidMount() {
        console.log('componentDidMount - Registration.js');

        // Get data we need to initialize the registration form
        const initialDataResponse = await axios.get("api/registration/init")
        const initialState = {
            initialData: {
                scheduledDates: initialDataResponse.data.scheduledSessionDatesByDay,
                unscheduledSessions: initialDataResponse.data.unscheduledSessionsByCategory
            }
        };


        // If arriving from an 'edit schedule', populate the registration form with existing data
        if (typeof this.props.location.state !== 'undefined') {
            if (this.props.location.state.submissionID > 0) {
                this.setState({ loading: true });
                const submissionID = this.props.location.state.submissionID; // retrieve submissionID from previous location
                const submissionData = await axios.get('api/submission/' + submissionID)
                const data = submissionData.data.data;

                // Update form with submissed sessions that are Scheduled
                const sessions = data.sessions;
                console.log(sessions)

                this.setState({
                    selectedSessions: sessions
                })

                // Find out if we need to set the filterDate for any scheduled day
                Object.entries(sessions.scheduled).forEach(([day, sessions]) => {
                    // Find first session for the scheduled day that doesn't have a category
                    const uncategorizedSession = sessions.find(session => !session.course.course_category_id);

                    // If there is an uncategorized session selected, set the dateFilter for that day to it
                    if (uncategorizedSession) {
                        this.setDateFilter("scheduled", day, uncategorizedSession.date)
                    }
                    // If not, try the same thing with categorized sessions
                    else {
                        const categorizedSession = sessions.find(session => session.course.course_category_id);
                        if (categorizedSession) this.setDateFilter("scheduled", day, categorizedSession.date);
                    }

                });


                // for each field returned in the data, set its value in the form
                for (const key in data) {
                    // If field doesn't exist, then we don't need to set its data
                    if (!this.props.form.getFieldInstance(key)) continue;

                    let value = data[key];

                    switch (key) {
                        case "startTime":
                        case 'endTime':
                        case 'employmentStartDate':
                        case 'newGradDate':
                            value = value ? moment(value) : value;
                    }


                    this.props.form.setFieldsValue({ [key]: value });
                }

                // put all data in state
                // console.log('putting data in state');
                this.setState({ data: data, loading: false });

            }
        } else {

        }

        this.setState({
            ...initialState
        });

    }

    // Called when a session is selected or deselected
    handleSessionSelected(event) {
        const target = event.target;
        console.log(target)
        const session = target.session;
        console.log(session)
        const key = session.course.type === "SCHEDULED" ? session.course.day : session.course.course_category_id;
        if (target.checked) {
            // add the session to the sessions array
            console.log("adding session to array");

            this.addSelectedSession(session.course.type.toLowerCase(), key, session);

        } else {
            // take the deselected session out of the sessions array
            console.log("removing session from array");
            this.removeSelectedSession(session.course.type.toLowerCase(), key, session);

        }
    }


    handleSubmit(event) {
        event.preventDefault();
        this.setState({ submitting: true });
        // Check form for errors and scroll to first error if so
        this.props.form.validateFieldsAndScroll((errors, values) => {
            values.sessions = this.getAllSelectedSessionIDs();
            console.log(values);
            const atLeastOnSession = values.sessions.length > 0;
            // If there are no errors and user has signed up for at least one session, continue
            if (!errors && atLeastOnSession) {
                // convert the employment start date from a moment object to a string
                values.employmentStartDate = values.employmentStartDate ? values.employmentStartDate.format('YYYY-MM-DD') : null;
                values.newGradDate = values.newGradDate ? values.newGradDate.format('YYYY-MM-DD') : null;

                // decide whether to create a new submission or to update an existing one
                // based on whether we are editing an existing one
                let subID = this.state.data.submissionID;
                let apiRoute = this.state.data.submissionID > 0
                    ? '/api/submission/' + this.state.data.submissionID
                    : '/api/submission';

                let dynamicFunction;
                if (subID > 0) {
                    dynamicFunction = axios.patch;
                } else {
                    dynamicFunction = axios.post;
                }

                dynamicFunction(apiRoute, values).then(response => {
                    console.log(response)
                    if (response && response.data && response.data.data && response.data.data.submissionID > 0) {

                        // reset the form
                        this.resetForm()

                        Modal.success({
                            title: 'Registration Complete',
                            content: 'Thank you. The registration form has been received. Once confirmed, the final orientation schedule will be sent to all emails on the registration form.',
                        });
                    } else {
                        // Something went wrong
                        console.dir(response);
                        this.setState({ submitting: false });
                        Modal.error({
                            title: 'Something Went Wrong',
                            content: response.data.message,
                        });
                    }
                })
                    .catch(error => {
                        console.dir(error);
                        this.setState({ submitting: false });
                        Modal.error({
                            title: 'Something Went Wrong',
                            content: 'Server error, please contact support',
                        });
                    })

            } else {
                // There are submission errors
                this.setState({ submitting: false });

                // If the only issue is that the user hasn't signed up for a session, let them know
                if (!atLeastOnSession && !errors) Modal.warning({
                    title: 'Missing Session',
                    content: 'Please sign up for at least one session before submitting.',
                });
            }
        });
    }

    render() {
        const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form;

        return (
            <Form onSubmit={this.handleSubmit}>
                <Spin spinning={this.state.loading}>
                    <Card title="New Hire Employee and Position Info">
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item label="First Name">
                                    {getFieldDecorator('firstName', {
                                        rules: [{ required: true, message: 'Please enter your First Name' }],
                                    })(
                                        <Input placeholder="First Name" maxLength={100} />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="Last Name">
                                    {getFieldDecorator('lastName', {
                                        rules: [{ required: true, message: 'Please enter your Last Name' }],
                                    })(
                                        <Input placeholder="Last Name" maxLength={100} />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="Email">
                                    {getFieldDecorator('email', {
                                        rules: [{
                                            required: true,
                                            message: 'Please enter a valid Email',
                                        }, { type: 'email', message: 'Please enter a valid Email' }],
                                    })(
                                        <Input placeholder="Email" maxLength={100} />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="Job Title">
                                    {getFieldDecorator('jobTitle', {
                                        rules: [{ required: true, message: 'Please enter your Job Title' }],
                                    })(
                                        <Input placeholder="Job Title" maxLength={100} />,
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={6}>
                                <FormItem name="employeeID" item="employee ID" placeholder="Employee ID"
                                    label="Employee ID" form={this.props.form} maxLength={100} />
                            </Col>
                            <Col span={6}>
                                <FormItem name="phone" item="phone number" placeholder="Phone" label="Phone"
                                    form={this.props.form} maxLength={100} />
                            </Col>
                            <Col span={6}>
                                <Form.Item label="Work Site">
                                    {getFieldDecorator('workSite', {
                                        rules: [{ required: true, message: 'Please enter your Work Site' }],
                                    })(
                                        <Input placeholder="Work Site" maxLength={100} />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="Department">
                                    {getFieldDecorator('department', {
                                        rules: [{ required: true, message: 'Please enter your Department' }],
                                    })(
                                        <Input placeholder="Department" maxLength={100} />,
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={6}>
                                <Form.Item label="Community of Care">
                                    {getFieldDecorator('coc', {
                                        rules: [{ required: true, message: 'Please enter a community of care.' }],
                                        initialValue: 'Bella Bella/Bella Coola',
                                    })(
                                        <Select>
                                            <Select.Option value="Bella Bella/Bella Coola">Bella Bella/Bella
                                                Coola</Select.Option>
                                            <Select.Option value="Corporate/Regional">Corporate/Regional</Select.Option>
                                            <Select.Option value="North Shore">North Shore</Select.Option>
                                            <Select.Option value="Powell River">Powell River</Select.Option>
                                            <Select.Option value="Richmond">Richmond</Select.Option>
                                            <Select.Option value="Sea to Sky">Sea to Sky</Select.Option>
                                            <Select.Option value="Sechelt/Sunshine Coast">Sechelt/Sunshine
                                                Coast</Select.Option>
                                            <Select.Option value="Vancouver">Vancouver</Select.Option>
                                        </Select>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="Sector">
                                    {getFieldDecorator('sector', {
                                        rules: [{ required: true, message: 'Please enter a sector.' }],
                                        initialValue: 'Acute',
                                    })(
                                        <Select>
                                            <Select.Option value="Acute">Acute</Select.Option>
                                            <Select.Option value="Community">Community</Select.Option>
                                            <Select.Option value="Corporate/Regional">Corporate/Regional</Select.Option>
                                            <Select.Option value="Long Term Care">Long Term Care</Select.Option>
                                        </Select>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <FormItem name="educatorEmail" item="educator email" placeholder="Educator Email"
                                    label="Educator Email" type="email" form={this.props.form}
                                    maxLength={100} />
                            </Col>
                            <Col span={6}>
                                <FormItem name="managerEmail" item="manager email" placeholder="Manager Email"
                                    label="Manager Email" type="email" form={this.props.form}
                                    maxLength={100} />
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={5}>
                                <Form.Item label="Requester Email (you)">
                                    {getFieldDecorator('requesterEmail', {
                                        rules: [{
                                            required: true,
                                            message: 'Please enter the requester\'s Email (you)',
                                        }, { type: 'email', message: 'Please enter a valid Email' }],
                                    })(
                                        <Input placeholder="Requester Email" maxLength={100} />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item label="Employment Start Date">
                                    {getFieldDecorator('employmentStartDate', {
                                        rules: [{
                                            type: 'object',
                                            message: 'Please enter an employment start date.',
                                            required: true,
                                        }],
                                    })(
                                        <DatePicker format="YYYY-MM-DD" />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={5}>
                                <Form.Item label="Hire Source">
                                    {getFieldDecorator('hireSource')(
                                        <Radio.Group>
                                            <Radio.Button value="Internal">Internal</Radio.Button>
                                            <Radio.Button value="External">External</Radio.Button>
                                        </Radio.Group>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="Employment Status">
                                    {getFieldDecorator('employmentStatus')(
                                        <Radio.Group>
                                            <Radio.Button value="Full-time">Full-time</Radio.Button>
                                            <Radio.Button value="Part-time">Part-time</Radio.Button>
                                            <Radio.Button value="Casual">Casual</Radio.Button>
                                        </Radio.Group>,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={3}>
                                <Form.Item label="Union">
                                    {getFieldDecorator('union', { rules: [{ message: 'Please enter a union.' }] })(
                                        <Select>
                                            <Select.Option value="Excluded">Excluded</Select.Option>
                                            <Select.Option value="BCGEU">BCGEU</Select.Option>
                                            <Select.Option value="BCNU">BCNU</Select.Option>
                                            <Select.Option value="CUPE">CUPE</Select.Option>
                                            <Select.Option value="HEU">HEU</Select.Option>
                                            <Select.Option value="HSA">HSA</Select.Option>
                                            <Select.Option value="UFCW">UFCW</Select.Option>
                                        </Select>,
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                    {/* <Card title="For New Grad Nurses" extra={ undefined }>
                        <Row gutter={ 16 } style={ { 'marginBottom': 0 } }>
                            <Col span={ 8 }>
                                <Form.Item label="School">
                                    { getFieldDecorator('newGradSchool', {
                                        rules: [],
                                    })(
                                        <Input placeholder="New Grad's School" maxLength={ 100 }/>,
                                    ) }
                                </Form.Item>
                            </Col>
                            <Col span={ 8 }>
                                <Form.Item label="Grad Date">
                                    { getFieldDecorator('newGradDate', {
                                        rules: [],
                                    })(
                                        <DatePicker format="YYYY-MM-DD"/>,
                                    ) }
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card> */}
                </Spin>

                <Spin spinning={this.state.loading}>
                    <Card title="Scheduled Learning (Days 1 - 4)">
                        {new Array(4).fill('').map((_, index) => index + 1).map((day) =>
                            <Card type="inner" title={"Day " + day} key={day}>
                                {this.state.initialData.scheduledDates && this.state.initialData.scheduledDates[day] &&
                                    <ScheduledSessions
                                        day={day}
                                        dates={this.state.initialData.scheduledDates[day]}
                                        handleSessionSelected={this.handleSessionSelected}
                                        selectedSessions={this.getSelectedSessions("scheduled", day)}
                                        dateFilter={this.getDateFilter("scheduled", day)}
                                        handleDateFilter={(newDate) => this.setDateFilter("scheduled", day, newDate)}
                                        form={this.props.form}
                                    />}
                            </Card>)}
                    </Card>
                </Spin>

                <Spin spinning={this.state.loading}>
                    <Card title="Additional Classes and Labs"
                        extra={<Popover placement="bottomRight" content={<FitTestingMessage />} trigger="click"
                            overlayClassName="fit-training-tooltip">
                            <i aria-label="icon: exclamation-circle"
                                className="anticon anticon-exclamation-circle ant-alert-icon"><Icon
                                    type="exclamation-circle" theme="outlined" /></i>
                            <span className="popover-target-text">Fit-Testing</span>
                        </Popover>}>

                        <Collapse>

                            {/* Iterate over and display all unscheduled course types  */}
                            {this.state?.initialData?.unscheduledSessions && Object.entries(this.state.initialData.unscheduledSessions).map(([key, sessions]) => {
                                const category = COURSE_CATEGORIES.find(x => x.id === key);
                                if (!category) return;
                                const type = category.id;
                                return (
                                    <Collapse.Panel header={category.label} key={key}>
                                        <UnscheduledSessions
                                            type={type}
                                            sessions={sessions}
                                            handleSessionSelected={this.handleSessionSelected}
                                            selectedSessions={this.getSelectedSessions("unscheduled", key)}
                                            form={this.props.form}
                                        />
                                    </Collapse.Panel>)
                            })}
                        </Collapse>
                    </Card>
                </Spin>
                {this.props.isAuthenticated &&
                    <Card title="Additional Notes">
                        <Form.Item>
                            {getFieldDecorator('notes')(
                                <TextArea name="notes" rows={4} maxLength={1000} />,
                            )}
                        </Form.Item>
                    </Card>
                }
                <Row type="flex" justify="end">
                    <Button type="primary" htmlType="submit" loading={this.state.submitting}>Submit
                        Registration</Button>
                </Row>
            </Form>
        );
    }
}

const mapStateToProps = state => {
    return { isAuthenticated: state.isAuthenticated }
}

export default Form.create()(connect(mapStateToProps)(RegistrationForm));
